import styled from 'styled-components';

export const StyledForm = styled.form`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

////////////////////
export const ErrorMessage = styled.div`
  color: tomato;
  margin: 10px 0;
  display: none;
`;
